import { render, staticRenderFns } from "./ModalCartGifts.vue?vue&type=template&id=6f6a48de"
import script from "./ModalCartGifts.vue?vue&type=script&lang=js"
export * from "./ModalCartGifts.vue?vue&type=script&lang=js"
import style0 from "./ModalCartGifts.vue?vue&type=style&index=0&id=6f6a48de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports